import * as React from "react";
import { forwardRef } from "react";
const SvgReply = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.13372 11.7335L2.40039 8.00012L6.13372 4.26678M2.40039 8.00012H9.86706C11.1118 8.00012 13.6004 8.74678 13.6004 11.7335", stroke: "#2F80ED", strokeWidth: 0.888889, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgReply);
export { ForwardRef as ReactComponent };
